const APP_STORE_URL = "https://apps.apple.com/app/doorly/id6773783248";
// App Store URL — update with actual App Store ID once approved.
// Current: using the app ID (6773783248) from the Build 5 submission. iOS app is
// in review; until it's live this link resolves to an App Store "not available"
// page, which is acceptable. Android/Google Play is intentionally NOT included yet.

export default function AppStoreBadge({ className = "" }) {
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label="Download Doorly on the App Store"
      style={{ display: "inline-block" }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="135"
        height="40"
        viewBox="0 0 135 40"
        role="img"
        aria-label="Download on the App Store"
      >
        <rect width="135" height="40" rx="8" fill="#000" />
        <path fill="#fff" d="M25.5 20.3a5.6 5.6 0 0 1 2.7-4.7 5.8 5.8 0 0 0-4.5-2.4c-1.9-.2-3.7 1.1-4.7 1.1-1 0-2.5-1.1-4.1-1.1a6 6 0 0 0-5.1 3.1c-2.2 3.8-.6 9.4 1.5 12.5 1.1 1.5 2.3 3.2 3.9 3.2 1.6-.1 2.2-1 4.1-1s2.5 1 4.2 1c1.7 0 2.8-1.5 3.8-3.1.8-1.1 1.3-2.3 1.6-3.6a5.4 5.4 0 0 1-3.4-5zm-3.1-9.8a5.5 5.5 0 0 0 1.3-3.9 5.6 5.6 0 0 0-3.6 1.9 5.2 5.2 0 0 0-1.3 3.7 4.6 4.6 0 0 0 3.6-1.7z"/>
        <text x="42" y="14" fill="#fff" fontFamily="-apple-system,BlinkMacSystemFont,'Helvetica Neue',sans-serif" fontSize="8" fontWeight="400" letterSpacing="0.2">Download on the</text>
        <text x="42" y="27" fill="#fff" fontFamily="-apple-system,BlinkMacSystemFont,'Helvetica Neue',sans-serif" fontSize="14" fontWeight="600" letterSpacing="0.3">App Store</text>
      </svg>
    </a>
  );
}
